import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Team.css';

const teamMembers = [
  {
    id: 1,
    name: 'Nicolas Machris',
    position: 'Managing Partner',
    image: '/images/Nicolas%20Machris.png',
    isPhoto: true,
    bio: 'Nicolas leads our global operations with over 25 years of experience in international corporate law and cross-border transactions. He has advised on some of the largest M&A deals in Europe and Asia.',
    specializations: ['Corporate Law', 'M&A', 'Private Equity', 'Cross-Border Transactions'],
    email: 'nicolasmachris@kingsbridgellp.com',
    phone: '+44 7490 947238',
    office: 'London'
  },
  {
    id: 2,
    name: 'David Clark',
    position: 'Director',
    image: 'DC',
    bio: "David oversees strategic initiatives and client relationships across our global network. With expertise in financial services and regulatory matters, he has been instrumental in shaping the firm's direction.",
    specializations: ['Financial Services', 'Regulatory Compliance', 'Strategic Advisory', 'Risk Management'],
    email: 'david.clark@kingsbridgellp.com',
    phone: '+1 212 878 8000',
    office: 'New York',
    linkedin: 'david-clark'
  },
  {
    id: 3,
    name: 'John Smith',
    position: 'Infrastructure Expert',
    image: 'JS',
    bio: 'John is a leading authority on infrastructure, energy, and project finance. He has advised governments and corporations on multi-billion dollar infrastructure projects across four continents.',
    specializations: ['Infrastructure', 'Project Finance', 'Energy Law', 'Public-Private Partnerships'],
    email: 'john.smith@kingsbridgellp.com',
    phone: '+971 4 503 2600',
    office: 'Dubai',
    linkedin: 'john-smith'
  }
];

const Team = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <section className="team-section" id="leadership">
      <div className="team-background">
        <div className="team-gradient"></div>
      </div>

      <div className="section-container">
        <motion.div
          className="team-header"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">OUR LEADERSHIP TEAM</span>
          <h1 className="section-title">
            Meet the Leaders
            <br />
            <span className="title-accent">Driving Excellence</span>
          </h1>
          <p className="section-description">
            Our leadership team brings together decades of experience, deep industry knowledge,
            and a commitment to delivering exceptional results for our clients worldwide.
          </p>
        </motion.div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.id}
              className="team-card"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ y: -10 }}
            >
              <div className="team-card-inner">
                <div className="member-image">
                  {member.isPhoto ? (
                    <img src={member.image} alt={member.name} className="member-photo" />
                  ) : (
                    <div className="member-avatar">{member.image}</div>
                  )}
                  <div className="member-overlay">
                    <button
                      className="view-profile-btn"
                      onClick={() => setSelectedMember(member)}
                    >
                      View Full Profile
                    </button>
                  </div>
                </div>

                <div className="member-info">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-position">{member.position}</p>
                  <p className="member-bio">{member.bio}</p>

                  <div className="member-specializations">
                    {member.specializations.slice(0, 2).map((spec) => (
                      <span key={spec} className="spec-tag">{spec}</span>
                    ))}
                  </div>

                  <div className="member-contact">
                    <div className="contact-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2 3h12v10H2V3z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                        <path d="M2 3l6 5 6-5" stroke="currentColor" strokeWidth="1.5" />
                      </svg>
                      <a href={`mailto:${member.email}`}>{member.email}</a>
                    </div>
                    <div className="contact-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 2h2l1 3-1 2c0 2 2 4 4 4l2-1 3 1v2a2 2 0 01-2 2C6 15 1 10 1 4a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                      </svg>
                      <a href={`tel:${member.phone}`}>{member.phone}</a>
                    </div>
                    <div className="contact-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <circle cx="8" cy="7" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
                        <path d="M8 14s-5-3-5-7c0-2.5 2-5 5-5s5 2.5 5 5c0 4-5 7-5 7z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                      </svg>
                      <span>{member.office}</span>
                    </div>
                  </div>

                  <button
                    className="member-contact-btn"
                    onClick={() => setSelectedMember(member)}
                  >
                    Contact {member.name.split(' ')[0]}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {selectedMember && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setSelectedMember(null)}
        >
          <motion.div
            className="contact-card-modal"
            initial={{ scale: 0.92, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.92, opacity: 0 }}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="close-modal"
              onClick={() => setSelectedMember(null)}
              aria-label="Close profile"
            >
              X
            </button>

            <div className="contact-card-header">
              {selectedMember.isPhoto ? (
                <img src={selectedMember.image} alt={selectedMember.name} className="contact-avatar-photo" />
              ) : (
                <div className="contact-avatar">{selectedMember.image}</div>
              )}
              <div>
                <h2>{selectedMember.name}</h2>
                <p className="contact-position">{selectedMember.position}</p>
              </div>
            </div>

            <div className="contact-card-body">
              <div className="contact-section">
                <h3>About</h3>
                <p>{selectedMember.bio}</p>
              </div>

              <div className="contact-section">
                <h3>Specializations</h3>
                <div className="specializations-list">
                  {selectedMember.specializations.map((spec) => (
                    <span key={spec} className="spec-badge">{spec}</span>
                  ))}
                </div>
              </div>

              <div className="contact-section">
                <h3>Contact Information</h3>
                <div className="contact-details">
                  <div className="detail-row">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M3 4h14v12H3V4z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                      <path d="M3 4l7 6 7-6" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                    <div>
                      <span className="detail-label">Email</span>
                      <a href={`mailto:${selectedMember.email}`} className="detail-value">
                        {selectedMember.email}
                      </a>
                    </div>
                  </div>

                  <div className="detail-row">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M4 3h3l2 4-2 2c0 3 2 5 5 5l2-2 4 2v3a2 2 0 01-2 2C7 19 1 13 1 5a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                    </svg>
                    <div>
                      <span className="detail-label">Phone</span>
                      <a href={`tel:${selectedMember.phone}`} className="detail-value">
                        {selectedMember.phone}
                      </a>
                    </div>
                  </div>

                  <div className="detail-row">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="9" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" />
                      <path d="M10 18s-6-4-6-9c0-3 2.5-6 6-6s6 3 6 6c0 5-6 9-6 9z" stroke="currentColor" strokeWidth="1.5" fill="none" />
                    </svg>
                    <div>
                      <span className="detail-label">Office</span>
                      <span className="detail-value">{selectedMember.office}</span>
                    </div>
                  </div>
                </div>
              </div>

              <Link to="/contact" className="primary-contact-btn" onClick={() => setSelectedMember(null)}>
                Schedule a Meeting
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 9H15M15 9L10 4M15 9L10 14" stroke="currentColor" strokeWidth="1.5" />
                </svg>
              </Link>
            </div>
          </motion.div>
        </motion.div>
      )}
    </section>
  );
};

export default Team;
